import { some } from 'lodash';

function validateFilterValue(options, filterValue, defaultValue) {
  return some(options, { value: filterValue }) ?
    filterValue :
    defaultValue;
}

export default validateFilterValue;
